<section>
    <p-confirmDialog [baseZIndex]="10000" key="positionDialog" [position]="dialogPosition" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">Email Channel</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> Email Channel</span>                       
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
  <section>
    <div class="card">
        <div class="col-md-12" *ngIf="isDistributionEmailSettingsEdit">
            <div class="card">
                <div class="devcare-card-header">
                    <span class="devcare-card-title">Email Channel Edit</span>
                </div>
                <div class="devcare-card-body">
                    <div class="row">
                        <div class="col-md-9">
                            <form [formGroup] = "distributionEmailSettingsForm">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-5">
                                    <label for="emailChannel">Email Channel<span class="required-field">*</span></label>
                                    <input id="emailChannel" type="text" formControlName="description" pInputText>
                                </div>
                               
                                <div class="p-field p-col-12 p-md-5">
                                    <label for="isActive">Send To Vendor's Distribution Email ID</label>
                                    <br />
                                    <p-inputSwitch id="isActive" formControlName="sendToDistributionEmail"></p-inputSwitch>
                                </div>
                            </div>
                            </form>
                        </div>
                        <div class="col-md-3 d-flex align-items-center">
                            <button pButton pRipple type="button" label="Update" icon="pi pi-check"
                        class="p-button-sm p-button-raised p-button-success m-2" [disabled]="!this.distributionEmailSettingsForm.valid" (click)="save(distributionEmailSettingsForm)"></button>
                    <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                        class="p-button-sm p-button-raised p-button-danger m-2" (click)="cancel()"></button>

                        </div>
                    </div>
                    
                </div>
                
            </div>
        </div>
        <div class="card-body" id="page-admin">
            <p-table id="distributionEmail" [value]="distributionEmail" [columns]="selectedColumns" [resizableColumns]="true" columnResizeMode="expand" styleClass="p-datatable-gridlines"
             scrollDirection="both" responsiveLayout="scroll" [paginator]="true" [rows]="10">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 4rem;"  pResizableColumn>Action</th>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;"  pResizableColumn>Email Channel</th>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;"  pResizableColumn>Send To Distribution Email</th>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 6rem;"  pResizableColumn>Created By</th>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 6rem;" pResizableColumn>Created On</th>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 6rem;"  pResizableColumn>Modified By</th>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;"  pResizableColumn>Modified On</th>                        
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-distributionEmail>
                    <tr>
                        <td style="width: 4rem">
                            <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                                (click)="selectedGridMenuItem = distributionEmail; menu.toggle($event)"></i></a>
                        <p-menu #menu [popup]="true" [model]="items" appendTo="body">
                        </p-menu></td>
                        <td style="width: 11rem">{{distributionEmail.description}}</td>
                        <td style="width: 11rem">{{distributionEmail.sendToDistributionEmail}}</td>
                        <td style="width: 6rem">{{distributionEmail.createdByUser.firstName}} {{distributionEmail.createdByUser.lastName}}</td>
                        <td style="width: 6rem">{{distributionEmail.createdOn | date:'MM/dd/yyyy'}}</td>
                        <td style="width: 6rem">{{distributionEmail.modifiedByUser.firstName}} {{distributionEmail.modifiedByUser.lastName}}</td>
                        <td style="width: 11rem">{{distributionEmail.modifiedOn | date:'MM/dd/yyyy'}}</td>                                             
                    </tr>
                </ng-template>
            </p-table>
        </div>       
    </div>
    <br><br><br><br>
</section>
<p-toast [baseZIndex]="100001" position="bottom-center"></p-toast>